import React from "react";
import classes from "./SecondaryFooter.module.scss";

import { CountryCode } from "config/BaseConfig";
import OpenInNewIcon from "../../../assets/img/open_in_new.svg";

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  return (
    <div className={classes["main_css_" + CountryCode]}>
      <div className={classes["footer-content"]}>
        <div className={classes["footer-container"]}>
          <ul className={classes["footer-links-list"]}>
            <li>
              <a href="https://www.revcomm.com/ja/" target="_blank" rel="noopener noreferrer">
                運営会社
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
            <li>
              <a href="https://www.revcomm.com/ja/rcr/" target="_blank" rel="noopener noreferrer">
                RevComm RCR
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
            <li>
              <a href="https://www.revcomm.com/ja/personal_information_protection_policy/" target="_blank" rel="noopener noreferrer">
                個人情報保護方針
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
            <li>
              <a href="https://www.revcomm.com/ja/terms/" target="_blank" rel="noopener noreferrer">
                ご利用規約
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
            <li>
              <a href="https://www.revcomm.com/ja/privacypolicy/" target="_blank" rel="noopener noreferrer">
                プライバシーポリシー&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;TOP
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
            <li>
              <a href="https://www.revcomm.com/ja/privacypolicy/all/" target="_blank" rel="noopener noreferrer">
                全利用者対象
                <img src={OpenInNewIcon} alt="外部リンク" className={classes["link-icon"]} />
              </a>
            </li>
          </ul>
          <div className={classes["bottom-copy-link"]}>
            © RevComm Inc.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
